/* import __COLOCATED_TEMPLATE__ from './phone-dialler-revealable-phone.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type PiiService from 'embercom/services/pii-service';
import type UserSummary from 'embercom/objects/inbox/user-summary';

interface Args {
  user: UserSummary;
  phoneNumber: string | undefined;
}

interface Signature {
  Args: Args;
  Element: HTMLSpanElement;
}

export default class PhoneDiallerRevealablePhone extends Component<Signature> {
  @service declare piiService: PiiService;

  @tracked isHovered = false;
  @tracked revealedValue: string | null = null;
  @tracked isRevealing = false;

  get displayValue(): string | undefined {
    return this.revealedValue ?? this.args.phoneNumber;
  }

  get isMasked(): boolean {
    return this.args.user.phoneMasked ?? false;
  }

  get showRevealButton(): boolean {
    return (
      this.isMasked && this.isHovered && !this.revealedValue && this.piiService.canRevealMaskedData
    );
  }

  @action
  onMouseEnter() {
    this.isHovered = true;
  }

  @action
  onMouseLeave() {
    this.isHovered = false;
  }

  @action
  async reveal() {
    if (this.isRevealing) {
      return;
    }

    this.isRevealing = true;
    try {
      let value = await this.piiService.revealField(this.args.user.id, 'phone');
      if (value !== null) {
        this.revealedValue = value;
      }
    } catch (e: unknown) {
      console.error('Failed to reveal phone number', e);
    } finally {
      this.isRevealing = false;
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::PhoneDiallerRevealablePhone': typeof PhoneDiallerRevealablePhone;
    'inbox2/calling/phone-dialler-revealable-phone': typeof PhoneDiallerRevealablePhone;
  }
}
